import { render, staticRenderFns } from "./carro.vue?vue&type=template&id=99505d80&"
import script from "./carro.vue?vue&type=script&lang=js&"
export * from "./carro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports